import type { createBrowserRouter } from 'react-router';
import { startAnalytics, trackPageView } from '@/shared/analytics';

type AppRouter = ReturnType<typeof createBrowserRouter>;

export interface AnalyticsDeps {
  router: AppRouter;
}

/**
 * GA4 배선 — 초기화 + 라우트 전환을 page_view 로 잇는다.
 *
 * SPA 는 문서 로드가 1회뿐이라 gtag 의 자동 page_view 로는 첫 화면밖에 못 잡는다. 라우터를 직접
 * 구독해 pathname 이 바뀔 때마다 보낸다 — `RouterProvider` 밖(트리 밖)이라 훅을 못 쓰므로
 * overlay 정리와 같은 방식으로 router 인스턴스를 구독한다.
 *
 * **pathname 만** 비교한다 — 검색 파라미터(필터 조작)까지 세면 슬라이더 한 번에 page_view 가
 * 수십 건씩 쌓인다. 같은 이유로 `trackPageView` 도 쿼리스트링을 싣지 않는다.
 *
 * `env.gaMeasurementId` 미설정이면 `startAnalytics` 가 no-op 이고 이후 전송도 전부 무시되므로,
 * 이 배선 자체는 어느 환경에서든 그대로 둬도 안전하다.
 */
export function initAnalytics({ router }: AnalyticsDeps): void {
  startAnalytics();

  let lastPathname = router.state.location.pathname;
  // 첫 화면 — `send_page_view: false` 라 자동 발화가 없다. 우리가 1건 보낸다.
  trackPageView(lastPathname);

  router.subscribe((state) => {
    if (state.location.pathname === lastPathname) return;
    lastPathname = state.location.pathname;
    trackPageView(lastPathname);
  });
}
